import { TravelRiskPackageCode } from '@app/domain/model/eshop/travel/TravelRiskPackageCode';

export function determineTravelRiskName(code: Nullable<string>): string {
    switch (code) {
        case TravelRiskPackageCode.MedicalExpenses:
            return 'eshop.travel.risks.medicalExpenses.name';
        case TravelRiskPackageCode.Accident:
            return 'eshop.travel.risks.accident.name';
        case TravelRiskPackageCode.Baggage:
            return 'eshop.travel.risks.baggage.name';
        case TravelRiskPackageCode.CivilResponsibility:
            return 'eshop.travel.risks.civilResponsibility.name';
        default:
            return '';
    }
}
